export const ROLES = {
    AdminLing: 10,
    Directer: 20,
    Admin: 30,
    AreaManager: 40,
    TeamLead: 50,
    Staff: 60
}
